import { IconButton, TooltipHost } from '@fluentui/react';
import { msalInstance } from '../../api/authConfig';
import { useTranslation } from '../../Locales/i18n/localizationService';

export const LogoutButton = () => {
	const { t } = useTranslation();
    const handleLogout = () => {
        try {
            // Initiate the logout by redirecting the user to the Azure AD logout endpoint
            msalInstance.logoutRedirect();
        } catch (error) {
            console.log('Logout error:', error);
        }
    };

    return (
        <TooltipHost content={t("UserDetails.SignOut")} id="signoutbutton" calloutProps={{ gapSpace: 0 }}>
            <IconButton id="signoutbutton" iconProps={{ iconName: 'SignOut' }} onClick={handleLogout} />
        </TooltipHost>
    );
};
